<div
  #cbpopup
  class="cwc-chatbot__popup hidden"
  [ngClass]="relativeSettings?.enabled && relativeSettings.popupPosition ?? 'left'"
  dir="ltr"
  (click)="onPopupClick()"
>
  <span class="cwc-chatbot__popup-name">Olivia</span>
  <div class="cwc-chatbot__popup-message">{{ message }}</div>
</div>
<div #cbfloat class="cwc-chatbot__float-container">
  <div class="cwc-chatbot__launcher" (click)="onToogleChat()">
    <img [attr.src]="chatbotImg"/>
  </div>
  <div *ngIf="isRelativePositionDisabled" class="cwc-chatbot__hide-button" (click)="onCloseButton()">
    <span class="icons-chatbot" role="img" aria-hidden=""></span>
  </div>
</div>
<div *ngIf="isRelativePositionDisabled" #cbdock class="cwc-chatbot__dock" (click)="onDockButton()">
  <span class="icons-chatbot" role="img" aria-hidden=""></span>
</div>
